// extracted by mini-css-extract-plugin
export default {"skipLink":"skipLink--l3VCH","rotation":"rotation--OLEaC"};